// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__HGq8g","head":"ProcedureTableInfo_head__28HJe"};